var map = {
	"./de/bg.jpg": "in4r",
	"./en/bg.jpg": "+ld2",
	"./es/bg.jpg": "0b8V",
	"./fr/bg.jpg": "qc98",
	"./ja/bg.jpg": "jMds",
	"./ko/bg.jpg": "ughf",
	"./pt/bg.jpg": "5e2c",
	"./ru/bg.jpg": "VMu3",
	"./tc/bg.jpg": "m2ha",
	"./th/bg.jpg": "ZJE8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "O45S";